import { render, staticRenderFns } from "./inline_diff_view.vue?vue&type=template&id=9315534a&"
import script from "./inline_diff_view.vue?vue&type=script&lang=js&"
export * from "./inline_diff_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports